import { ComponentProps } from 'react';
import OtherTransactionInfo from './OtherTransactionInfo';

type OtherTransactionContainerProps = Omit<ComponentProps<typeof OtherTransactionInfo>, 'transaction'>;

export default function OtherTransactionContainer(props: OtherTransactionContainerProps) {
  return (
    <div>
      <OtherTransactionInfo {...props} />
    </div>
  );
}
